import { render, staticRenderFns } from "./SmsPriorityRule.vue?vue&type=template&id=20650a2f&"
import script from "./SmsPriorityRule.vue?vue&type=script&lang=ts&"
export * from "./SmsPriorityRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports